import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page-wrapper">
      <Navbar />

      {/* Contact Section 1 */}
      <section className="contact-section1">
        <div className="contact-section1-container">
          <div className="contact-section1-intro">
            <h2 className="contact-section1-heading">Get in Touch with SR Marbles & Granites</h2>
            <p className="contact-section1-description">
              Have questions or need assistance? We’re here to help. Whether you're planning a renovation, selecting materials, or seeking advice, our team is ready to assist you. Call, email, or visit one of our branches.
            </p>
            <div className="contact-section1-shared">
              <div className="shared-item">
                <span>Phone</span>
                <a href="tel:+919704048939">+91 9704048939</a>
              </div>
              <div className="shared-item">
                <span>Email</span>
                <a href="mailto:srmarblesgranites6@gmail.com">srmarblesgranites6@gmail.com</a>
              </div>
            </div>
          </div>

          <div className="contact-branches">
            <div className="branch-card">
              <div className="branch-top">
                <h3 className="branch-title">Main Showroom</h3>
                <p className="branch-address">
                  Dr.no 7-3-17 a/2, Saraswati Mahal Backside, Gonti Veedhi, Srikakulam, Andhra Pradesh 532001
                </p>
              </div>
              <div className="branch-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3788.0242433070152!2d83.90046977371416!3d18.300499475862495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3c150f72a591fd%3A0x3cd19bbb831e0f56!2sSR%20Marbles%2C%20granites%20%26%20Tiles!5e0!3m2!1sen!2sin!4v1754641018086!5m2!1sen!2sin"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  title="SR Marbles & Granites Main Showroom"
                />
              </div>
              <div className="branch-bottom">
                <a className="branch-contact" href="tel:+919704048939">Call: +91 9704048939</a>
                <a className="branch-contact" href="mailto:srmarblesgranites6@gmail.com">Email: srmarblesgranites6@gmail.com</a>
              </div>
            </div>

            <div className="branch-card">
              <div className="branch-top">
                <h3 className="branch-title">Second Branch</h3>
                <p className="branch-address">
                  Keswaraopeta Village, Near NH 16 Highway Bridge Road, Etcherla, Srikakulam
                </p>
              </div>
              <div className="branch-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30306.015352237333!2d83.8148085!3d18.2900841!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3c15e2b18db881%3A0x16e1147c3447ad3c!2sSR%20MARBLES%20AND%20GRANITES!5e0!3m2!1sen!2sin!4v1755526077962!5m2!1sen!2sin"
                  width="600"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="SR Marbles & Granites"
                />
              </div>

              <div className="branch-bottom">
                <a className="branch-contact" href="tel:+919704048939">Call: +91 9704048939</a>
                <a className="branch-contact" href="mailto:srmarblesgranites6@gmail.com">Email: srmarblesgranites6@gmail.com</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-section2">
        <div className="contact-section2-container">

          <div className="contact-section2-right">
            <img
              src="/images/contact1.jpeg"
              alt="Marble Work"
              className="contact-section2-image"
            />
          </div>
          <div className="contact-section2-left">
            <h2 className="contact-section2-heading">Our Expertise</h2>
            <p className="contact-section2-description">
              At SR Marbles & Granites, we specialize in offering premium marble and granite solutions for a variety of applications. Whether you're looking for countertops, flooring, or other custom marble and granite work, our team ensures the highest standards of craftsmanship and quality.
            </p>

            <div className="contact-section2-info">
              <h3>Why Choose Us?</h3>
              <ul>
                <li>Top-quality materials from trusted quarries.</li>
                <li>Experienced artisans and craftsmen.</li>
                <li>Timely delivery and exceptional customer service.</li>
                <li>Customized solutions tailored to your needs.</li>
              </ul>
            </div>
          </div>


        </div>
      </section>


      <Footer />
    </div>

  );
};

export default Contact;
